let mutations = {
    permiso(state, permiso, roles) {
        state.permisos = permiso
        state.roles = roles
    },
    rol(state, roles) {
        state.roles = roles
        
    },
    routeChange(state,loader){
      if (loader == "start") {
        state.loading = true
    } else if (loader == "end") {
        state.loading = false
    }

    }
}
export default mutations
